import { render } from "./LoginFaceInvitation.vue?vue&type=template&id=7447f828&ts=true"
import script from "./LoginFaceInvitation.vue?vue&type=script&lang=ts"
export * from "./LoginFaceInvitation.vue?vue&type=script&lang=ts"

import "./LoginFaceInvitation.vue?vue&type=style&index=0&id=7447f828&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__